import { NotificationTemplate, NotificationViewModel } from '@ail/notifications-api'
import { printDate } from '../../../../helpers/Utils'
import './ActivityItem.scss'
interface Props {
  item: NotificationViewModel
  icon?: string
}

export default function ActivityItem({ item, icon }: Props) {
  function isAlert(item: NotificationViewModel) {
    return item.templateName === NotificationTemplate.ReportAvailable
  }
  return (
    <li className={`activityItem ${isAlert(item) ? 'alert' : ''}`} key={item.id}>
      <div className="flex">
        <i className={icon ?? ''} />
        <div className="itemText">
          <div className="itemTitle">
            {isAlert(item) && <i className="icon-warning" />}
            {item.subject}
          </div>
          <span className="itemBody">{item.body}</span>
        </div>
      </div>
      <span className="itemDate">
        {printDate(item.createdAt)}
        <br />
        {printDate(item.createdAt, false)}
      </span>
    </li>
  )
}
